import { Config } from '@chegg-wt/core/config'
import { AppState } from '@chegg-wt/core/state/types'
import { CHEGG } from '@chegg-wt/core/constants/site'
import { getOrSetVCookie } from '@chegg-wt/core/utils/getVCookie'
import { isProduction } from '@chegg-wt/core/utils/env'
import { resolveRioPromise } from '@chegg-wt/core/state/optimizely/optimizely'
import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'
import { getCookie, Cookies } from '@chegg-wt/core/utils/cookies'
import { AppRouteName } from '@chegg-wt/core/types/core'
import {
  PROD_RIO_ENDPOINT,
  NON_PROD_RIO_ENDPOINT,
  APP_ID,
  BUSINESS_UNIT,
} from '../constants'
import { initializeRioClient } from '../rioAnalytics'
import {
  getAuthState,
  getCheggUserUuid,
  productMap,
  getSubscriptionStatus,
} from '../../utils/auth'
import { viewExperienceMap } from '../../utils'
import { routeToRioPageNameMap } from '../../utils/pageNames'
import getAllocationMap from './getAllocationMap'

interface initRioProps {
  routeName: AppRouteName
  state: AppState
}

const getExpCookie = () => getCookie(Cookies.RioClientExperiments)

const initRio = ({ routeName, state }: initRioProps) => {
  const page = routeToRioPageNameMap[routeName]

  const site = Config.tokenSiteCode

  const allocationMap = getAllocationMap(state)
  const isProd = isProduction()
  const LOG_EVENT_LAMBDA_URL = isProd ? PROD_RIO_ENDPOINT : NON_PROD_RIO_ENDPOINT
  const RSW_ENDPOINT = LOG_EVENT_LAMBDA_URL

  initializeRioClient({
    endpoint: RSW_ENDPOINT,
    appId: APP_ID,
    property: site,
    authState: getAuthState(state),
    cheggUuid: getCheggUserUuid(state) || undefined,
    testCells: allocationMap,
    errorHandler: trackWithoutThrow,
    uvn: getOrSetVCookie(Config.cookieDomain),
    clientExperiments: getExpCookie(),
    subscriptions: [{ product: productMap[site], status: getSubscriptionStatus(state) }],
    view: {
      property: site === CHEGG ? CHEGG : BUSINESS_UNIT,
      experience: viewExperienceMap[site],
      view_name: page || '',
    },
  })
  resolveRioPromise()
}

export default initRio
